import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';

function PostCard({ post, onFavorite, isFavorite }) {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate(`/post/${post.id}`);
  };

  return (
    <div className="post-card">
      <img src={post.image} alt={post.title} className="post-image" />
      <div className="post-content">
        <h3>{post.title}</h3>
        <div className="post-meta">
          <span>{post.date}</span>
          <span>{post.author}</span>
        </div>
        <p className="post-excerpt">{post.excerpt}</p>
        <div className="post-actions">
          <button onClick={handleReadMore} className="btn btn-primary">
            <FaShoppingCart /> Weiterlesen
          </button>
        
          <button 
            onClick={() => onFavorite(post.id)} 
            className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
          >
            <FaHeart /> Favorit
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostCard;